import React, { useEffect, useState } from "react";
import { ReactComponent as DownArrowIcon } from "../../../../assets/appearencePage/arrow-down.svg";
import { ReactComponent as DownArrowIconDark } from "../../../../assets/appearencePage/arrow-down-dark.svg";

import { ReactComponent as MainIcon } from "../../../../assets/appearencePage/shapes.svg";
import { ReactComponent as MainIconDark } from "../../../../assets/appearencePage/shapes-dark.svg";
import { useStateContext } from "../../../../contexts/ThemeContext";
import { ReactComponent as BackgroundIcon } from "../../../../assets/appearencePage/gallery-edit-white.svg";
import { ReactComponent as BackgroundIconBW } from "../../../../assets/appearencePage/gallery-edit.svg";
import { ReactComponent as BackgroundIconBWDark } from "../../../../assets/appearencePage/gallery-edit-dark.svg";
import { ReactComponent as FavIcon } from "../../../../assets/appearencePage/favIcon-white.svg";
import { ReactComponent as FavIconBW } from "../../../../assets/appearencePage/favIcon-black.svg";
import { ReactComponent as FavIconBWDark } from "../../../../assets/appearencePage/favIcon-black-dark.svg";
import { ReactComponent as TextIcon } from "../../../../assets/appearencePage/font-white.svg";
import { ReactComponent as TextBW } from "../../../../assets/appearencePage/font-black.svg";
import { ReactComponent as TextBWDark } from "../../../../assets/appearencePage/font-black-dark.svg";
import { ReactComponent as SeoIcon } from "../../../../assets/appearencePage/seo-white.svg";
import { ReactComponent as SeoBW } from "../../../../assets/appearencePage/seo-black.svg";
import { ReactComponent as SeoBWDark } from "../../../../assets/appearencePage/seo-black-dark.svg";
import { ReactComponent as AvatarIcon } from "../../../../assets/appearencePage/avatar-white.svg";
import { ReactComponent as AvatarBW } from "../../../../assets/appearencePage/avatar-black.svg";
import { ReactComponent as AvatarBWDark } from "../../../../assets/appearencePage/avatar-black-dark.svg";
import { ReactComponent as LinkIcon } from "../../../../assets/appearencePage/link-white.svg";
import { ReactComponent as LinkBW } from "../../../../assets/appearencePage/link-black.svg";
import { ReactComponent as LinkBWDark } from "../../../../assets/appearencePage/link-black-dark.svg";

import { Outlet, useNavigate } from "react-router-dom";

import { useDispatch, useSelector } from "react-redux";
import { resetBackgroundSettings } from "../../../../redux/slices/appearance/createBackgroundSettingsSlice";
import { resetFavSettings } from "../../../../redux/slices/appearance/createFavSettingsSlice";
import { resetFontSettings } from "../../../../redux/slices/appearance/createFontSettingsSlice";
import { resetBrandingSettings } from "../../../../redux/slices/appearance/createBrandingSettingSlice";
import { resetSeoSettings } from "../../../../redux/slices/appearance/createSeoSettingSlice";
import { resetAvatarSettings } from "../../../../redux/slices/appearance/createAvatarSettingsSlice";
import { resetLinkSettings } from "../../../../redux/slices/appearance/createLinkSettingsSlice";

import {
  gettingSettingUpdataData,
  getScreenPreviewSetting,
} from "../../../../redux/slices/appearance/appearanceSlice";
import Navbar from "../../../../components/landingPage/header/Navbar";

import { toast } from "react-hot-toast";

// Accordions
import {
  BackgroundAcc,
  FavIconAcc,
  FontAcc,
  BrandingAcc,
  SeoAcc,
  AvatarAcc,
  LinkAcc,
} from "./accordions/index";
import useLocales from "../../../../hooks/useLocales";
import { Helmet } from "react-helmet";
import OgImage from "../../../../assets/landingPages/homePage/Hero.png";

const Appearance = () => {
  const { darkMode } = useSelector((state) => state.theme);
  const dispatch = useDispatch();
  const navigate = useNavigate();
  const { translate } = useLocales();
  const { setActiveAppearancePageNav } = useStateContext();

  const [textAccordion, setTextAccordion] = useState(false);

  const [brandingAccordion, setBrandingAccordion] = useState(false);
  const [seoAccordion, setSeoAccordion] = useState(false);
  const [avatarAccordion, setAvatarAccordion] = useState(false);
  const [linkAccordion, setLinkAccordion] = useState(false);

  // backgorund states and accordion states
  const [backgroundAccordion, setBackgroundAccordion] = useState(false);

  // favicon states, funtions and accordions states
  const [faviconAccordion, setFaviconAccordion] = useState(false);

  useEffect(() => {
    setActiveAppearancePageNav(true);
    return () => {
      setActiveAppearancePageNav(false);
    };
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, []);
  const setBrandingAccordionFun = (value) => {
    setBrandingAccordion(value);
  };

  // prev setting getting
  const pageName = JSON.parse(localStorage.getItem("user"))?.twofactor
    ?.pageName;
  const userId = JSON.parse(localStorage.getItem("user"))?.userid;
  const linkId = localStorage?.getItem("linkId");
  const user = {
    userData: userId,
    linkData: linkId,
  };
  useEffect(() => {
    dispatch(gettingSettingUpdataData(user));
    dispatch(getScreenPreviewSetting(pageName));
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, []);

  // background setting response handlers
  const {
    backgroundStateError,
    backgroundStateSuccess,
    backgroundStateLoading,
  } = useSelector((state) => state?.backgroundSettings);
  const { status, message } = useSelector(
    (state) => state?.backgroundSettings?.background
  );
  useEffect(() => {
    if (status === "success" && backgroundStateSuccess) {
      toast.success(message);
      navigate("/dashboard/appearance");
      setBackgroundAccordion(false);
    }
    if (status === "failed" && backgroundStateSuccess) {
      toast.error(message);
    }
    dispatch(resetBackgroundSettings());
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [
    backgroundStateError,
    backgroundStateSuccess,
    dispatch,
    backgroundStateLoading,
  ]);

  // favicon settings response handlers
  const { favStateError, favStateSuccess, favStateLoading } = useSelector(
    (state) => state?.favSettings
  );
  const { status: favStatus, message: favMessage } = useSelector(
    (state) => state?.favSettings?.fav
  );
  useEffect(() => {
    if (favStatus === "success" && favStateSuccess) {
      toast.success(favMessage);
      navigate("/dashboard/appearance");
      setFaviconAccordion(false);
    }
    dispatch(resetFavSettings());
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [favStateError, favStateSuccess, dispatch, favStateLoading]);

  // font setting response handler
  const { fontStateError, fontStateSuccess, fontStateLoading } = useSelector(
    (state) => state?.fontSetting
  );
  const { status: fontStatus, message: fontMessage } = useSelector(
    (state) => state?.fontSetting?.font
  );
  useEffect(() => {
    if (fontStatus === "success" && fontStateSuccess) {
      toast.success(fontMessage);
      navigate("/dashboard/appearance");
      setTextAccordion(false);
    }
    dispatch(resetFontSettings());
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [fontStateError, fontStateSuccess, dispatch, fontStateLoading]);

  // Branding setting response handler
  const { brandingStateError, brandingStateSuccess, brandingStateLoading } =
    useSelector((state) => state?.brandingSettings);
  const { status: barndingStatus, message: brandingMessage } = useSelector(
    (state) => state?.brandingSettings?.branding
  );
  useEffect(() => {
    if (barndingStatus === "success" && brandingStateSuccess) {
      toast.success(brandingMessage);
      navigate("/dashboard/appearance");
      setBrandingAccordion(false);
    }
    dispatch(resetBrandingSettings());
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [
    brandingStateError,
    brandingStateSuccess,
    dispatch,
    brandingStateLoading,
  ]);

  // Seo setting response handler
  const { seoStateError, seoStateSuccess, seoStateLoading } = useSelector(
    (state) => state?.seoSettings
  );
  const { status: seoStatus, message: seoMessage } = useSelector(
    (state) => state?.seoSettings?.seo
  );
  useEffect(() => {
    if (seoStatus === "success" && seoStateSuccess) {
      toast.success(seoMessage);
      navigate("/dashboard/appearance");
      setSeoAccordion(false);
    }
    dispatch(resetSeoSettings());
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [seoStateError, seoStateSuccess, dispatch, seoStateLoading]);

  // Avatar setting response handler
  const { avatarStateError, avatarStateSuccess, avatarStateLoading } =
    useSelector((state) => state?.avatarSettings);
  const { status: avatarStatus, message: avatarMessage } = useSelector(
    (state) => state?.avatarSettings?.avatar
  );
  useEffect(() => {
    if (avatarStatus === "success" && avatarStateSuccess) {
      toast.success(avatarMessage);
      navigate("/dashboard/appearance");
      setAvatarAccordion(false);
    }
    dispatch(resetAvatarSettings());
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [avatarStateError, avatarStateSuccess, dispatch, avatarStateLoading]);

  // Link response handler
  const { linkStateError, linkStateSuccess, linkStateLoading } = useSelector(
    (state) => state?.linkSettings
  );
  const { status: linkStatus, message: linkMessage } = useSelector(
    (state) => state?.linkSettings?.link
  );
  useEffect(() => {
    if (linkStatus === "success" && linkStateSuccess) {
      toast.success(linkMessage);
      navigate("/dashboard/appearance");
      setLinkAccordion(false);
    }
    dispatch(resetLinkSettings());
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [linkStateError, linkStateSuccess, dispatch, linkStateLoading]);

  return (
    <>
      {/* { /  <Navbar /> /} */}
      <Helmet>
        <meta charSet="utf-8" />
        <title>Appearance | Bil.Bio</title>
        <meta property="og:title" content="Appearance | Bil.Bio" />
        <meta property="og:url" content={window.location.href} />
        <meta property="og:image" content={window.location.origin + OgImage} />
        <meta property="og:description" content="Create Bio Link page" />
        <meta property="og:type" content="website" />
        <meta name="twitter:card" content="summary" />
        <meta name="twitter:title" content="Bil.Bio" />
        <meta
          name="twitter:description"
          content="Bil.Bio | All links in link"
        />
        <meta name="twitter:site" content="@BilBioHQ" />
        <meta name="twitter:image" content={window.location.origin + OgImage} />
      </Helmet>
      <div className="bg-light_bg_v4 dark:bg-dark-primary h-[100vh] sm:px-[76px]  md:px-10 lg:px-12 xl:px-[76px] md:py-9 overflow-y-auto">
        <div className="hidden xl:p-5 xl:pb-0 mb-11 md:flex items-center gap-[10px]">
          <div
            style={{
              boxShadow: darkMode
                ? ""
                : "0px 0px 10px rgba(217, 217, 217, 0.1), -5px 6px 10px rgba(170, 170, 170, 0.3)",
            }}
            className="hidden md:flex justify-center items-center p-[9px] bg-white dark:bg-dark-secondary rounded-lg  "
          >
            {darkMode ? <MainIconDark /> : <MainIcon />}
          </div>
          <h6 className=" text-custom_h6 text-heading_color dark:text-color_v1_dark">
            {/* {/ Appearance /} */}
            {translate("cms.appearance")}
          </h6>
        </div>
        <div className="hidden xl:px-5 md:flex flex-col gap-5">
          <div
            className={`dark:border-color_dark bg-light_bg_v5 dark:bg-dark-secondary rounded-[10px] ${
              backgroundAccordion
                ? "px-[25px] py-[30px] border border-light_bg_v2"
                : "p-2 pr-[13px]"
            } `}
          >
            <div
              onClick={() => setBackgroundAccordion(!backgroundAccordion)}
              className="flex  gap-2 justify-between items-center cursor-pointer"
            >
              <div className={`${backgroundAccordion ? "" : "p-[5px]"} `}>
                {backgroundAccordion ? (
                  darkMode ? (
                    <BackgroundIconBWDark className="md:h-6 md:w-6 " />
                  ) : (
                    <BackgroundIconBW className="md:h-6 md:w-6 " />
                  )
                ) : (
                  <div
                    style={{
                      boxShadow: `-2px 3px 7px #754A9133`,
                    }}
                    className={`p-2 h-[36px] w-[36px] rounded-lg bg-gradient-to-br from-[#754A91] to-[#54008A]`}
                  >
                    <BackgroundIcon className={`h-full w-full`} />
                  </div>
                )}
              </div>
              <div className="text-small1 text-heading_color w-full">
                {backgroundAccordion ? (
                  <p className="text-small1_bold text-dark_bg_v1 dark:text-color_v1_dark">
                    {/* {/ BACKGROUND /} */}
                    {translate("appearance.background_cap")}
                  </p>
                ) : (
                  <p className="text-small1 text-heading_color dark:text-color_v1_dark">
                    {/* {/ Background /} */}
                    {translate("appearance.background")}
                  </p>
                )}
              </div>
              {backgroundAccordion ? (
                <div className="text-xl ">
                  {darkMode ? (
                    <DownArrowIconDark className="rotate-180" />
                  ) : (
                    <DownArrowIcon className="rotate-180" />
                  )}
                </div>
              ) : (
                <div className="text-xl ">
                  {darkMode ? <DownArrowIconDark /> : <DownArrowIcon />}
                </div>
              )}
            </div>
            {backgroundAccordion && <BackgroundAcc />}
          </div>
          <div
            className={`dark:border-color_dark bg-light_bg_v5 dark:bg-dark-secondary rounded-[10px] ${
              faviconAccordion
                ? "px-[25px] py-[30px] border border-light_bg_v2"
                : "p-2 pr-[13px]"
            } `}
          >
            <div
              onClick={() => setFaviconAccordion(!faviconAccordion)}
              className="flex  gap-2 justify-between items-center cursor-pointer"
            >
              <div className={`${faviconAccordion ? "" : "p-[5px]"} `}>
                {faviconAccordion ? (
                  darkMode ? (
                    <FavIconBWDark />
                  ) : (
                    <FavIconBW />
                  )
                ) : (
                  <div
                    style={{
                      boxShadow: `-2px 3px 7px #FF784255`,
                    }}
                    className={`p-2 h-[36px] w-[36px] rounded-lg bg-gradient-to-br  from-[#FF7842] to-[#EA4C0E]`}
                  >
                    <FavIcon className={`h-full w-full`} />
                  </div>
                )}
              </div>
              <div className="text-small1 text-heading_color w-full">
                {faviconAccordion ? (
                  <p className="text-small1_bold text-dark_bg_v1 dark:text-color_v1_dark">
                    {/* {/ FAVICON /} */}
                    {translate("appearance.favicon_cap")}
                  </p>
                ) : (
                  <p className="text-small1 text-heading_color dark:text-color_v1_dark">
                    {/* {/ Favicon /} */}
                    {translate("appearance.favicon")}
                  </p>
                )}
              </div>
              {faviconAccordion ? (
                <div className="text-xl ">
                  {darkMode ? (
                    <DownArrowIconDark className="rotate-180" />
                  ) : (
                    <DownArrowIcon className="rotate-180" />
                  )}
                </div>
              ) : (
                <div className="text-xl ">
                  {darkMode ? <DownArrowIconDark /> : <DownArrowIcon />}
                </div>
              )}
            </div>
            {faviconAccordion && <FavIconAcc />}
          </div>
          <div
            className={`dark:border-color_dark bg-light_bg_v5 dark:bg-dark-secondary rounded-[10px] ${
              textAccordion
                ? "px-[25px] py-[30px] border border-light_bg_v2"
                : "p-2 pr-[13px]"
            } `}
          >
            <div
              onClick={() => setTextAccordion(!textAccordion)}
              className="flex  gap-2 justify-between items-center cursor-pointer"
            >
              <div className={`${textAccordion ? "" : "p-[5px]"} `}>
                {textAccordion ? (
                  darkMode ? (
                    <TextBWDark />
                  ) : (
                    <TextBW />
                  )
                ) : (
                  <div
                    style={{
                      boxShadow: `-2px 3px 7px #0CA8F655`,
                    }}
                    className={`p-2 h-[36px] w-[36px] rounded-lg bg-gradient-to-br from-[#0CA8F6] to-[#0096E1]`}
                  >
                    <TextIcon className={`h-full w-full`} />
                    <></>
                  </div>
                )}
              </div>
              <div className="text-small1 text-heading_color w-full dark:text-color_v1_dark">
                {textAccordion ? (
                  <p className="text-small1_bold text-dark_bg_v1 dark:text-color_v1_dark">
                    {/* {/ FONTS /} */}
                    {translate("appearance.fonts_cap")}
                  </p>
                ) : (
                  <p className="text-small1 text-heading_color dark:text-color_v1_dark">
                    {/* {/ Fonts /} */}
                    {translate("appearance.fonts")}
                  </p>
                )}
              </div>
              {textAccordion ? (
                <div className="text-xl ">
                  {darkMode ? (
                    <DownArrowIconDark className="rotate-180" />
                  ) : (
                    <DownArrowIcon className="rotate-180" />
                  )}
                </div>
              ) : (
                <div className="text-xl ">
                  {darkMode ? <DownArrowIconDark /> : <DownArrowIcon />}
                </div>
              )}
            </div>
            {textAccordion && <FontAcc />}
          </div>
          <BrandingAcc
            brandingAccordion={brandingAccordion}
            setBrandingAccordionFun={setBrandingAccordionFun}
          />
          <div
            className={`dark:border-color_dark bg-light_bg_v5 dark:bg-dark-secondary rounded-[10px] ${
              seoAccordion
                ? "px-[25px] py-[30px] border border-light_bg_v2"
                : "p-2 pr-[13px]"
            } `}
          >
            <div
              onClick={() => setSeoAccordion(!seoAccordion)}
              className="flex gap-2.5 justify-between items-center cursor-pointer"
            >
              <div className={`${seoAccordion ? "" : "p-[5px]"} `}>
                {seoAccordion ? (
                  darkMode ? (
                    <SeoBWDark />
                  ) : (
                    <SeoBW />
                  )
                ) : (
                  <div
                    style={{
                      boxShadow: `-2px 3px 7px #FF519055`,
                    }}
                    className={`p-2 h-[36px] w-[36px] rounded-lg bg-gradient-to-br from-[#FF5190] to-[#D7155B]`}
                  >
                    <SeoIcon className={`h-full w-full`} />
                  </div>
                )}
              </div>

              <div className="text-small1 text-heading_color dark:text-color_v1_dark w-full">
                {seoAccordion ? (
                  <p className="text-small1_bold text-dark_bg_v1 dark:text-color_v1_dark">
                    {/* {/ SEO /} */}
                    {translate("appearance.seo_cap")}
                  </p>
                ) : (
                  <p className="text-small1 text-heading_color dark:text-color_v1_dark">
                    {/* {/ Seo /}  */}
                    {translate("appearance.seo")}
                  </p>
                )}
              </div>

              {seoAccordion ? (
                <div className="text-xl cursor-pointer">
                  {darkMode ? (
                    <DownArrowIconDark className="rotate-180" />
                  ) : (
                    <DownArrowIcon className="rotate-180" />
                  )}
                </div>
              ) : (
                <div className="text-xl cursor-pointer">
                  {darkMode ? <DownArrowIconDark /> : <DownArrowIcon />}
                </div>
              )}
            </div>
            {seoAccordion && <SeoAcc />}
          </div>
          <div
            className={`dark:border-color_dark bg-light_bg_v5 dark:bg-dark-secondary rounded-[10px] ${
              avatarAccordion
                ? "px-[25px] md:px-[18px] lg:px-[25px] py-[30px] border border-light_bg_v2"
                : "p-2 pr-[13px]"
            } `}
          >
            <div
              onClick={() => setAvatarAccordion(!avatarAccordion)}
              className="flex  gap-2 justify-between items-center cursor-pointer"
            >
              <div className={`${avatarAccordion ? "" : "p-[5px]"} `}>
                {avatarAccordion ? (
                  darkMode ? (
                    <AvatarBWDark />
                  ) : (
                    <AvatarBW />
                  )
                ) : (
                  <div
                    style={{
                      boxShadow: `-2px 3px 7px #32323255`,
                    }}
                    className={`p-2 h-[36px] w-[36px] rounded-lg bg-gradient-to-br from-[#323232] to-[#000000]`}
                  >
                    <AvatarIcon className={`h-full w-full`} />
                  </div>
                )}
              </div>

              <div className="text-small1 text-heading_color w-full">
                {avatarAccordion ? (
                  <p className="text-small1_bold text-dark_bg_v1 dark:text-color_v1_dark">
                    {/* {/ AVATAR /} */}
                    {translate("appearance.avatar_cap")}
                  </p>
                ) : (
                  <p className="text-small1 text-heading_color dark:text-color_v1_dark">
                    {/* {/ Avatar /} */}
                    {translate("appearance.avatar")}
                  </p>
                )}
              </div>

              {avatarAccordion ? (
                <div className="text-xl cursor-pointer">
                  {darkMode ? (
                    <DownArrowIconDark className="rotate-180" />
                  ) : (
                    <DownArrowIcon className="rotate-180" />
                  )}
                </div>
              ) : (
                <div className="text-xl cursor-pointer">
                  {darkMode ? <DownArrowIconDark /> : <DownArrowIcon />}
                </div>
              )}
            </div>
            {avatarAccordion && <AvatarAcc />}
          </div>
          <div
            className={`dark:border-color_dark bg-light_bg_v5 dark:bg-dark-secondary rounded-[10px] ${
              linkAccordion
                ? "px-[25px] py-[30px] border border-light_bg_v2"
                : "p-2 pr-[13px]"
            } `}
          >
            <div
              onClick={() => setLinkAccordion(!linkAccordion)}
              className="flex  gap-2 justify-between items-center cursor-pointer"
            >
              <div className={`${linkAccordion ? "" : "p-[5px]"} `}>
                {linkAccordion ? (
                  darkMode ? (
                    <LinkBWDark />
                  ) : (
                    <LinkBW />
                  )
                ) : (
                  <div
                    style={{
                      boxShadow: `-2px 3px 7px #F452FF55`,
                    }}
                    className={`p-2 h-[36px] w-[36px] rounded-lg bg-gradient-to-br from-[#F452FF] to-[#832BC1]`}
                  >
                    <LinkIcon className={`h-full w-full`} />
                  </div>
                )}
              </div>

              <div className="text-small1 text-heading_color w-full ">
                {linkAccordion ? (
                  <p className="text-small1_bold text-dark_bg_v1 dark:text-color_v1_dark">
                    {/* {/ LINK /} */}
                    {translate("appearance.link_cap")}
                  </p>
                ) : (
                  <p className="text-small1 text-heading_color dark:text-color_v1_dark">
                    {/* {/ Link /} */}
                    {translate("appearance.link")}
                  </p>
                )}
              </div>

              {linkAccordion ? (
                <div className="text-xl cursor-pointer">
                  {darkMode ? (
                    <DownArrowIconDark className="rotate-180" />
                  ) : (
                    <DownArrowIcon className="rotate-180" />
                  )}
                </div>
              ) : (
                <div className="text-xl cursor-pointer">
                  {darkMode ? <DownArrowIconDark /> : <DownArrowIcon />}
                </div>
              )}
            </div>
            {linkAccordion && <LinkAcc />}
          </div>
        </div>
        <div className="md:hidden">
          <Outlet />
        </div>
      </div>
    </>
  );
};

export default Appearance;
